import React from 'react';
import { useFileExplorerContext } from '../../hooks/useFileExplorerContext';
import { FileExplorerGridItem } from './FileExplorerGridItem';
import { FolderGridItemActions, FileGridItemActions } from './FileExplorerGridItemActions';
import { FileExplorerDropzone } from './FileExplorerDropzone';

export function FileExplorerGridContent() {
  const { activeFolder, newlyAddedItems } = useFileExplorerContext();
  const { folders, files } = activeFolder?.content || {};
  if (!activeFolder) return null;

  return (
    <div className="file-explorer-grid p-4 z-1">
      {folders?.map((folder) => (
        <FileExplorerGridItem
          key={folder.id}
          nodeTitle={folder.name}
          kind="folder"
          actionsDropdown={<FolderGridItemActions node={folder} />}
          isNewlyAdded={newlyAddedItems.has(folder.id)}
        />
      ))}
      {files?.map((file) => (
        <FileExplorerGridItem
          key={file.id}
          nodeTitle={file.title}
          kind="file"
          isNewlyAdded={newlyAddedItems.has(file.id)}
          actionsDropdown={(
            <FileGridItemActions
              node={file}
              permissions={activeFolder.permissions}
              activeFolder={activeFolder}
            />
          )}
        />
      ))}
    </div>
  );
}

function FileExplorerGridEmptyState() {
  return (
    <div className="h-100 w-100 d-flex flex-column align-items-center justify-content-center gap-2">
      <img src="/static/img/icons/folder.svg" alt="Folder" height={64} />
      <span className="fs-6 fw-semibold">Selecciona una carpeta</span>
      <p className="w-50 text-center text-muted">
        Selecciona una carpeta para interactuar con su contenido.
      </p>
    </div>
  );
}

export function FileExplorerGrid() {
  const { activeFolder } = useFileExplorerContext();

  return (
    <FileExplorerDropzone>
      <div className="file-explorer-grid-container">
        {activeFolder ? (
          <FileExplorerGridContent />
        ) : (
          <FileExplorerGridEmptyState />
        )}
      </div>
    </FileExplorerDropzone>
  );
}
